import React, { FC, ReactElement } from "react";
import { Heading, Icon } from "@telia/teddy";
import cn from "classnames";
import "./MemberCardStep.less";

interface Props {
    children: ReactElement | ReactElement[];
    isDisabled?: boolean;
    label: string;
    onClick: () => void;
    selectedStep: string | undefined;
    stepId: string;
}

const MemberCardStep: FC<Props> = ({ label, isDisabled, onClick, stepId, selectedStep, children }) => {
    if (stepId === selectedStep) {
        return (
            <div className="member-card-step member-card-step__content">
                <Heading as="h2" className="member-card-step__heading">
                    {label}
                </Heading>
                <div>{children}</div>
            </div>
        );
    }

    if (isDisabled) {
        return (
            <div
                className={cn("member-card-step", {
                    "member-card-step__disabled": true,
                })}
            >
                <Heading as="h3" className="member-card-step__disabled-heading">
                    {label}
                </Heading>
            </div>
        );
    }

    return (
        <button className="member-card-step member-card-step--editable" onClick={onClick}>
            <div className="member-card-step__collapser-left-wrapper">
                <div className="member-card-step__collapser-icon">
                    <Icon size="lg" name="check-circle" aria-hidden="true" focusable="false" />
                </div>
                <Heading as="h3" className="member-card-step__collapser-heading">
                    {label}
                </Heading>
            </div>
            <div className="member-card-step__edit-btn">
                <span className="member-card-step__edit-btn-text">Endre</span>
                <span className="member-card-step__edit-btn-icon">
                    <Icon size="sm" name="edit" aria-hidden="true" focusable="false" />
                </span>
            </div>
        </button>
    );
};

export default MemberCardStep;
